import { render, staticRenderFns } from "./RobberyHouseSecuredQuestion.vue?vue&type=template&id=8dd7115a&scoped=true"
import script from "./RobberyHouseSecuredQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyHouseSecuredQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyHouseSecuredQuestion.vue?vue&type=style&index=0&id=8dd7115a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd7115a",
  null
  
)

export default component.exports